import type { Dict } from '../utils'

import { createContext } from '../utils'

const [AccordionProvider, useAccordionContext] = createContext<Dict>({ isOptional: true })

export { AccordionProvider, useAccordionContext }
